<template>
    <div class="h-100 overflow-hidden">
        <img class="w-100 h-100" src="@/assets/images/home-sith-new.png">
    </div>
</template>

<script>
export default {
    name: "home"
};
</script>
